import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/carousel.css';

// Custom arrow components for navigation
const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="arrow next-arrow" onClick={onClick}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="currentColor" />
        <path
          d="M10 8l4 4-4 4"
          stroke="#FFFFFF"
          
        />
      </svg>
    </button>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="arrow prev-arrow" onClick={onClick}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="currentColor" />
        <path
          d="M14 16l-4-4 4-4"
          stroke="#FFFFFF"
        />
      </svg>
    </button>
  );
};

function Gallery() {

    const [images, setImages] = useState([]);

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      nextArrow: <NextArrow />, // Custom right arrow
      prevArrow: <PrevArrow />, // Custom left arrow
    };

     useEffect(() => {
       // Fetch images from the server
       const fetchImages = async () => {
         try {
           const response = await fetch("/imgs/fotos/fotos.json");
           const data = await response.json();
           setImages(data);
         } catch (error) {
           console.error("Error fetching images:", error);
         }
       };

       fetchImages();
     }, []);
    
    return (
      <section id="gallery">
        <h2>Imagens</h2>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} className="carousel-item">
              <a href={image}>
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  className="carousel-image"
                />
              </a>
            </div>
          ))}
        </Slider>
      </section>
    );
}

export default Gallery;